//! moment.js locale configuration
//! locale : Uyghur (China) [ug-cn]
//! author: boyaq : https://github.com/boyaq

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ugCn = moment.defineLocale('ug-cn', {
        months: 'ÙØ§ÙÛØ§Ø±_ÙÛÛØ±Ø§Ù_ÙØ§Ø±Øª_Ø¦Ø§Ù¾Ø±ÛÙ_ÙØ§Ù_Ø¦ÙÙÛÙ_Ø¦ÙÙÛÙ_Ø¦Ø§ÛØºÛØ³Øª_Ø³ÛÙØªÛØ¨ÙØ±_Ø¦ÛÙØªÛØ¨ÙØ±_ÙÙÙØ§Ø¨ÙØ±_Ø¯ÛÙØ§Ø¨ÙØ±'.split(
            '_'
        ),
        monthsShort:
            'ÙØ§ÙÛØ§Ø±_ÙÛÛØ±Ø§Ù_ÙØ§Ø±Øª_Ø¦Ø§Ù¾Ø±ÛÙ_ÙØ§Ù_Ø¦ÙÙÛÙ_Ø¦ÙÙÛÙ_Ø¦Ø§ÛØºÛØ³Øª_Ø³ÛÙØªÛØ¨ÙØ±_Ø¦ÛÙØªÛØ¨ÙØ±_ÙÙÙØ§Ø¨ÙØ±_Ø¯ÛÙØ§Ø¨ÙØ±'.split(
                '_'
            ),
        weekdays: 'ÙÛÙØ´ÛÙØ¨Û_Ø¯ÛØ´ÛÙØ¨Û_Ø³ÛÙØ´ÛÙØ¨Û_ÚØ§Ø±Ø´ÛÙØ¨Û_Ù¾ÛÙØ´ÛÙØ¨Û_Ø¬ÛÙÛ_Ø´ÛÙØ¨Û'.split(
            '_'
        ),
        weekdaysShort: 'ÙÛ_Ø¯Û_Ø³Û_ÚØ§_Ù¾Û_Ø¬Û_Ø´Û'.split('_'),
        weekdaysMin: 'ÙÛ_Ø¯Û_Ø³Û_ÚØ§_Ù¾Û_Ø¬Û_Ø´Û'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-ÙÙÙÙM-Ø¦Ø§ÙÙÙÚ­D-ÙÛÙÙ',
            LLL: 'YYYY-ÙÙÙÙM-Ø¦Ø§ÙÙÙÚ­D-ÙÛÙÙØ HH:mm',
            LLLL: 'ddddØ YYYY-ÙÙÙÙM-Ø¦Ø§ÙÙÙÚ­D-ÙÛÙÙØ HH:mm',
        },
        meridiemParse: /ÙÛØ±ÙÙ ÙÛÚÛ|Ø³ÛÚ¾ÛØ±|ÚÛØ´ØªÙÙ Ø¨ÛØ±ÛÙ|ÚÛØ´|ÚÛØ´ØªÙÙ ÙÛÙÙÙ|ÙÛÚ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'ÙÛØ±ÙÙ ÙÛÚÛ' ||
                meridiem === 'Ø³ÛÚ¾ÛØ±' ||
                meridiem === 'ÚÛØ´ØªÙÙ Ø¨ÛØ±ÛÙ'
            ) {
                return hour;
            } else if (meridiem === 'ÚÛØ´ØªÙÙ ÙÛÙÙÙ' || meridiem === 'ÙÛÚ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'ÙÛØ±ÙÙ ÙÛÚÛ';
            } else if (hm < 900) {
                return 'Ø³ÛÚ¾ÛØ±';
            } else if (hm < 1130) {
                return 'ÚÛØ´ØªÙÙ Ø¨ÛØ±ÛÙ';
            } else if (hm < 1230) {
                return 'ÚÛØ´';
            } else if (hm < 1800) {
                return 'ÚÛØ´ØªÙÙ ÙÛÙÙÙ';
            } else {
                return 'ÙÛÚ';
            }
        },
        calendar: {
            sameDay: '[Ø¨ÛÚ¯ÛÙ Ø³Ø§Ø¦ÛØª] LT',
            nextDay: '[Ø¦ÛØªÛ Ø³Ø§Ø¦ÛØª] LT',
            nextWeek: '[ÙÛÙÛØ±ÙÙ] dddd [Ø³Ø§Ø¦ÛØª] LT',
            lastDay: '[ØªÛÙÛÚ¯ÛÙ] LT',
            lastWeek: '[Ø¦Ø§ÙØ¯ÙÙÙÙ] dddd [Ø³Ø§Ø¦ÛØª] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ÙÛÙÙÙ',
            past: '%s Ø¨ÛØ±ÛÙ',
            s: 'ÙÛÚÚÛ Ø³ÛÙÙÙØª',
            ss: '%d Ø³ÛÙÙÙØª',
            m: 'Ø¨ÙØ± ÙÙÙÛØª',
            mm: '%d ÙÙÙÛØª',
            h: 'Ø¨ÙØ± Ø³Ø§Ø¦ÛØª',
            hh: '%d Ø³Ø§Ø¦ÛØª',
            d: 'Ø¨ÙØ± ÙÛÙ',
            dd: '%d ÙÛÙ',
            M: 'Ø¨ÙØ± Ø¦Ø§Ù',
            MM: '%d Ø¦Ø§Ù',
            y: 'Ø¨ÙØ± ÙÙÙ',
            yy: '%d ÙÙÙ',
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-ÙÛÙÙ|-Ø¦Ø§Ù|-Ú¾ÛÙ¾ØªÛ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-ÙÛÙÙ';
                case 'w':
                case 'W':
                    return number + '-Ú¾ÛÙ¾ØªÛ';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/Ø/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, 'Ø');
        },
        week: {
            // GB/T 7408-1994ãæ°æ®ååäº¤æ¢æ ¼å¼Â·ä¿¡æ¯äº¤æ¢Â·æ¥æåæ¶é´è¡¨ç¤ºæ³ãä¸ISO 8601:1988ç­æ
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return ugCn;

})));
